import type { TextInputProps, ViewProps } from 'react-native'
import { Button, type IButtonProps } from '~/components/button'
import {
  InputCounter,
  type TInputCounterProps,
} from '~/components/input-counter'
import type { InputCounterButtonProps } from '~/components/input-counter/components/input-counter-button'
import { type IInputTextProps, InputText } from '~/components/input-text'
import { Refresh } from '~/components/refresh'
import * as S from './action.styles'

export type ActionProps = {
  variantAction?: 'buy' | 'ofex' | 'nostock' | 'availability'

  actionType?: 'input-text' | 'button' | 'input-counter' | 'loading'

  buttonProps?: Omit<IButtonProps, 'variant' | 'size' | 'full' | 'children'>

  inputTextProps?: {
    root?: Omit<IInputTextProps, 'size'>
    field?: TextInputProps
    clearButton: Omit<IButtonProps, 'children' | 'variant' | 'size' | 'full'>
  }
  inputCounterProps?: {
    root?: Omit<TInputCounterProps, 'size' | 'errorText'>
    minusButton?: InputCounterButtonProps
    plusButton?: InputCounterButtonProps
  }
} & Omit<ViewProps, 'style'>

const Action = ({
  variantAction,
  actionType = 'button',
  buttonProps,
  inputTextProps,
  inputCounterProps,
  ...rest
}: ActionProps) => {
  if (actionType === 'loading') {
    return (
      <S.Container {...rest}>
        <Refresh size="md" color="black" />
      </S.Container>
    )
  }

  if (actionType === 'button') {
    const getButtonLabel = () => {
      switch (variantAction) {
        case 'nostock':
          return 'Avise-me'
        case 'availability':
          return 'Consultar'
        case 'ofex':
          return 'Ativar oferta'
        default:
          return 'Comprar'
      }
    }
    return (
      <S.Container {...rest}>
        <Button.Root
          variant={
            variantAction === 'ofex' || variantAction === 'availability' ? 'neutral-secondary' : 'brand-primary'
          }
          size="lg"
          full
          {...buttonProps}
        >
          <Button.Label>{getButtonLabel()}</Button.Label>
        </Button.Root>
      </S.Container>
    )
  }

  if (actionType === 'input-text') {
    return (
      <S.Container {...rest}>
        <InputText.Root size="lg" {...inputTextProps?.root}>
          <InputText.Actions>
            <InputText.Field {...inputTextProps?.field} />
            <InputText.Button {...inputTextProps?.clearButton} />
          </InputText.Actions>
          <InputText.HelperText withIcon iconName="rdicon-location">
            Insira seu CEP
          </InputText.HelperText>
        </InputText.Root>
      </S.Container>
    )
  }

  if (
    actionType === 'input-counter' &&
    typeof inputCounterProps?.root?.value === 'number'
  ) {
    return (
      <S.Container {...rest}>
        <InputCounter.Root errorText="" size="lg" {...inputCounterProps.root}>
          <InputCounter.MinusButton {...inputCounterProps.minusButton} />
          <InputCounter.PlusButton {...inputCounterProps.plusButton} />
        </InputCounter.Root>
      </S.Container>
    )
  }
}

export { Action }
